import React, { Fragment } from 'react';
import PropTypes, { object } from 'prop-types';
import { useTranslation } from 'react-i18next';

import Account from '../Account/Account';

import {
  Table,
  Member,
  TableCell,
  DateTime,
  HealthPoint
} from 'components/common/Elements/Elements';

import { moneyFormater, getInitialsFull } from 'utils/common';

import classes from './PageTable.module.scss';

const TableRow = ({
  company,
  tableConf,
  row,
  mouseEnter,
  handleCheckCustomer,
  isSelectedCustomer,
  CheckBox,
  selectedCustomers
}) => {
  const { t } = useTranslation(['activity']);

  const createMember = user => {
    return {
      fullName: user,
      initials: getInitialsFull(user)
    };
  };

  return (
    <Table.Row className={classes.row}>
      {tableConf.map(({ show, field }, ind) => {
        const cellProps = {
          row: row,
          mouseEnter: mouseEnter,
          ind: ind,
          field: field,
          classes: classes
        };

        return (
          <Fragment key={`${field}-${company.email}}`}>
            {show && field === 'companyName' && (
              <TableCell cellProps={cellProps}>
                <CheckBox
                  selectedCustomers={selectedCustomers}
                  disabled={true}
                  company={company}
                  handleCheck={handleCheckCustomer}
                  isSelected={isSelectedCustomer(company.customerId)}
                />
                <Account data={company} />
              </TableCell>
            )}
            {show && field === 'plan' && (
              <TableCell cellProps={cellProps}>{company.plan}</TableCell>
            )}
            {show && field === 'arr' && (
              <TableCell cellProps={cellProps}>
                {moneyFormater(company.arr)}
              </TableCell>
            )}

            {show && field === 'accountManager' && (
              <TableCell cellProps={cellProps}>
                {company.accountManager &&
                company.accountManager !==
                  t('activity:customers:UNASSIGNED') ? (
                  <Member member={createMember(company.accountManager)} />
                ) : (
                  t('activity:customers:UNASSIGNED')
                )}
              </TableCell>
            )}
            {show && field === 'customerSuccessEngineer' && (
              <TableCell cellProps={cellProps}>
                {company.customerSuccessEngineer &&
                company.customerSuccessEngineer !==
                  t('activity:customers:UNASSIGNED') ? (
                  <Member
                    member={createMember(company.customerSuccessEngineer)}
                  />
                ) : (
                  t('activity:customers:UNASSIGNED')
                )}
              </TableCell>
            )}
            {show && field === 'billingCycle' && (
              <TableCell cellProps={cellProps}>
                {company.billingCycle}
              </TableCell>
            )}
            {show && field === 'firstPaymentDate' && (
              <TableCell cellProps={cellProps}>
                <DateTime date={company.firstPaymentDate} />
              </TableCell>
            )}
            {show && field === 'nextBillingDate' && (
              <TableCell cellProps={cellProps}>
                <DateTime date={company.nextBillingDate} />
              </TableCell>
            )}
            {show && field === 'firstInvoiceAt' && (
              <TableCell cellProps={cellProps}>
                <DateTime date={company.firstInvoiceAt} />
              </TableCell>
            )}
            {show && field === 'healthStatus' && (
              <TableCell cellProps={cellProps}>
                <HealthPoint
                  data={{
                    point: company.healthPoint,
                    status: company.healthStatus
                  }}
                />
              </TableCell>
            )}
          </Fragment>
        );
      })}
    </Table.Row>
  );
};

TableRow.propTypes = {
  company: PropTypes.object,
  tableConf: PropTypes.arrayOf(object),
  row: PropTypes.string,
  mouseEnter: PropTypes.func,
  handleCheckCustomer: PropTypes.func,
  isSelectedCustomer: PropTypes.func,
  CheckBox: PropTypes.func,
  selectedCustomers: PropTypes.number
};

export default TableRow;
